// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

export type UrlParams = {
  id: 'string';
};
